module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "row scroll-outer scroll-padding-bottom"
  }, [_c('div', {
    staticClass: "span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('p', {
    staticClass: "large",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.markedCards), function(card, index) {
    return _c('flip-card', {
      key: index,
      attrs: {
        "ind": index,
        "active": _vm.active,
        "icon": card.icon,
        "title": card.title,
        "cardSize": _vm.card_size
      },
      on: {
        "flip": _vm.change_flip_count
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(card.paragraph)
      }
    })])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "utility bump-up-24 bump-down-12-mobile"
  }, [_c('strong', [_vm._v("Click")]), _vm._v(" through each tile to flip before proceeding to "), _c('strong', [_vm._v("'Next'")]), _vm._v(" button. ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57ff0304"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/pages/flip_card_page.vue
// module id = 628
// module chunks = 1